import { BeamButton } from "./BeamButton";
import useTranslation from "../../client/hooks/useTranslation";
import ScrollAnimation from "./ScrollAnimation";
import { trackLandingCta } from '../../client/utils/posthog';
import { Link as WaspRouterLink, routes } from 'wasp/client/router';

export default function CtaFinal() {
  const t = useTranslation();

  return (
    <section className="relative py-20 sm:py-24 overflow-hidden mx-[calc(-50vw+50%)] w-screen">
      {/* Background */}
      <div className="pointer-events-none absolute inset-0 bg-background-subtle" />

      {/* HUD grid */}
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0,201,167,0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,201,167,0.05) 1px, transparent 1px)
          `,
          backgroundSize: "48px 48px",
        }}
      />

      {/* Central glow */}
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-64 w-[600px] rounded-full bg-primary/8 blur-3xl" />

      {/* HUD corner decorations */}
      <div className="pointer-events-none absolute top-8 left-8 w-8 h-8 border-t-2 border-l-2 border-primary/30 rounded-tl-sm" />
      <div className="pointer-events-none absolute top-8 right-8 w-8 h-8 border-t-2 border-r-2 border-primary/30 rounded-tr-sm" />
      <div className="pointer-events-none absolute bottom-8 left-8 w-8 h-8 border-b-2 border-l-2 border-primary/30 rounded-bl-sm" />
      <div className="pointer-events-none absolute bottom-8 right-8 w-8 h-8 border-b-2 border-r-2 border-primary/30 rounded-br-sm" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8 text-center">
        <ScrollAnimation direction="up">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
            {t.landing.ctaFinal.title}
          </h2>
          <p className="mt-3 text-sm text-muted-foreground font-medium tracking-wide">
            ✦ {t.landing.ctaFinal.badge}
          </p>
          <div className="mt-8 flex flex-col items-center gap-3">
            <WaspRouterLink to={routes.SignupRoute.to} className="w-full sm:w-auto">
              <BeamButton className="px-10 text-base" showArrow onClick={() => trackLandingCta('cta_final')}>
                {t.landing.ctaFinal.cta}
              </BeamButton>
            </WaspRouterLink>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
